export default {
  "content": "<path d=\"M22 20.5H2v-2h20v2z\" fill=\"#7B61FF\"/><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M14.5 4.5H13v1.544c4.997.45 8.5 4.272 8.5 9.456a1 1 0 01-1 1h-17a1 1 0 01-1-1c0-5.184 3.503-9.006 8.5-9.456V4.5H9.5v-2h5v2zM12 8c-4.077 0-7.013 2.624-7.443 6.5h14.886C19.013 10.624 16.077 8 12 8z\" fill=\"#7B61FF\"/>",
  "attrs": {
    "width": "24",
    "height": "24",
    "viewBox": "0 0 24 24",
    "fill": "none",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};